// extracted by css-extract-rspack-plugin
export default {"placeholder":"lfrTG","blink":"xzatX"};